import { HttpClient } from '@angular/common/http';
import {Injectable, OnDestroy, signal} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ApiHelper} from './api.helper';
import {SearchResultsCareproviderUnitItem} from '../types/SearchResultsCareproviderUnitItem';
import {ToolsService} from './tools.service';
import {LoaderService} from './loader.service';
import {AppConfigService} from './app-config.service';
import {DataLayerListItemsEcommerceItem} from '../types/DataLayerListItemsEcommerceItem';
import {DLPageTypeEnum} from '../enums/DataLayerEnums';
import {DataLayerListItemsTag} from '../types/DataLayerListItemsTag';
import {GtmEventEnum} from '../enums/GoogleEnums';
import {GtmService} from './gtm.service';

@Injectable({providedIn: 'root'})
export class ClosebySearchService implements OnDestroy {
  public closebyItems = signal<Array<SearchResultsCareproviderUnitItem>>(null);

  private subscriptions: Subscription[] = [];
  private loadedId: number = 0;

  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private tools: ToolsService,
    private loaderService: LoaderService,
    private appConfigService: AppConfigService,
    private gtmService: GtmService,
  ) {}

  public ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public updateClosebyItems(careproviderUnitId: number, pageType: DLPageTypeEnum): void {
    if (this.loadedId !== careproviderUnitId) {
      this.loadedId = careproviderUnitId;

      this.subscriptions.push(
        this.getClosebyProviders(careproviderUnitId)
          .pipe(map((result) => result.filter((a) => a.id !== careproviderUnitId)))
          .subscribe(
            (result) => {
              this.pushViewItemListEventToDataLayer(result, pageType);
              this.closebyItems.set(result);
            },
            (error) => console.error(error),
          ),
      );
    }
  }

  private getClosebyProviders(careproviderUnitId: number): Observable<Array<SearchResultsCareproviderUnitItem>> {
    return this.http
      .get<Array<SearchResultsCareproviderUnitItem>>(
        this.appConfigService.appConfig.apiUrl + `search/careprovider/${careproviderUnitId}/widget/nearby`,
      )
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  private pushViewItemListEventToDataLayer(
    results: SearchResultsCareproviderUnitItem[],
    pageType: DLPageTypeEnum,
  ): void {
    const items: DataLayerListItemsEcommerceItem[] = [];
    results.forEach((item) => {
      const ecommerceItem: DataLayerListItemsEcommerceItem = {
        item_id: item.itemId,
        cpru_id: item.id,
        careservice_id: item.careServiceId,
        Pagetype: pageType,
        careservice_type: item.careServiceTypeId,
        mainCareProviderTypeId: item.mainCaregiverUnitType ? item.mainCaregiverUnitType.id : null,
      };
      items.push(ecommerceItem);
    });
    if (items.length > 0) {
      const tag: DataLayerListItemsTag = {
        event: GtmEventEnum.VIEW_ITEM_LIST,
        ecommerce: {
          items: items,
        },
      };
      this.gtmService.pushTag(tag, true);
    }
  }
}
